<div *ngIf="isPageReady" class="flex flex-col h-full">
  <div class="qb-content-card flex-1">
    <div class="qb-detail-card w-full h-fit">
      <div class="flex flex-col gap-3">
        <!-- Row 1: Feature (12) -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Feature" class="col-span-12">
            <input pInputText [ngModel]="featureChoice.feature.name" [disabled]="true" title="Feature" />
          </qb-field>
        </div>
        <!-- Row 2: Choice (6) + Reorder Feature Choice (6) -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Choice" class="col-span-6">
            <input
              #firstInput
              pInputText
              [(ngModel)]="featureChoice.choiceValue"
              [bzModel]="featureChoice"
              name="choiceValue"
              title="Choice"
              [disabled]="isMeaningLocked"
            />
          </qb-field>
          <qb-field label="Reorder Feature Choice" class="col-span-6">
            <p-dropdown
              [options]="availableFeatureChoices"
              [(ngModel)]="featureChoice.reorderFeatureChoiceId"
              [bzModel]="featureChoice"
              name="reorderFeatureChoiceId"
              optionValue="id"
              optionLabel="choiceValue"
              [disabled]="isMeaningLocked"
            />
          </qb-field>
        </div>
        <div *ngIf="isMeaningLocked" class="text-sm" style="color: var(--p-orange-600, #ea580c)">
          This choice is on {{ productUse!.UsedProducts === 1 ? '1 product that was' : productUse!.UsedProducts + ' products that were' }} used on orders. You cannot change its name or its
          reorder choice. Make a new choice. Then put this choice on Phaseout.
        </div>
        <!-- Row 3: Display Order (3) + Status (3) -->
        <div class="grid grid-cols-12 gap-3">
          <qb-field label="Display Order" class="col-span-3">
            <p-inputNumber [(ngModel)]="featureChoice.displayOrder" [bzModel]="featureChoice" name="displayOrder" />
          </qb-field>
          <qb-field label="Status" class="col-span-3">
            <p-dropdown
              [options]="activeStatuses"
              [(ngModel)]="featureChoice.activeStatusId"
              [bzModel]="featureChoice"
              name="activeStatusId"
              optionValue="id"
              optionLabel="name"
            />
          </qb-field>
        </div>
      </div>
    </div>

    <!-- What is in flight on the products that carry this choice. Information only. -->
    <div *ngIf="!isAdding" class="mt-3">
      <app-product-exposure-panel [featureChoiceId]="featureChoice.id" (loaded)="productUse = $event"></app-product-exposure-panel>
    </div>
  </div>

  <div class="flex flex-row gap-2 justify-start mt-4">
    <button (click)="ok()" pButton type="button" label="Ok" title="Ok" icon="pi pi-check" class="p-button-raised"></button>
    <button (click)="cancel()" pButton type="button" label="Cancel" title="Cancel" icon="pi pi-times" class="p-button-raised"></button>
  </div>
</div>
